export enum MediaType {
  IMAGE = "image",
  VIDEO = "video",
  AUDIO = "audio",
  YOUTUBE = "youtube",
  VIMEO = "vimeo",
  SKETCHFAB = "sketchfab",
  DOCUMENT = "document",
  DM = "dm",
  MODEL_3D = "model3d",
}

export default MediaType;
